import { useEffect, useRef } from 'react';

export function useReturnFocus(active: boolean): void {
  const previouslyFocused = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (active) {
      previouslyFocused.current = document.activeElement as HTMLElement | null;
      return;
    }

    const previous = previouslyFocused.current;
    if (previous && previous.isConnected && typeof previous.focus === 'function') {
      previous.focus();
    }
  }, [active]);
}
